<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qAjhkA/tc-custom/9780802197351.jpg?1707880533056" alt="This image is the cover for the book Pack of Cards"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pack of Cards
      </h1>
      <p class="bookDescription body article font2">
        <b>An “abundantly rich collection” of short stories by the Man Booker Prize–winning author (<i>The New York Times Book Review</i>).</b><br/>  <br/> In <i>Pack of Cards</i>, Penelope Lively shares moments in the everyday world that are not always open to observation, as she delves into the minutiae of her characters’ lives.<br/>  <br/> Whether she writes about a widow on a visit to Russia, a small boy’s consignment to boarding school, or an agoraphobic housewife, Lively takes the reader behind a closed curtain, through the locked door, and into a world that seems at first mundane—then proves to be uniquely memorable.<br/>  <br/> “Witty, profoundly civilized . . . This captivatingly intelligent collection confirms Lively’s place as one of Britain’s most imaginative and important contemporary writers.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Penelope Lively
      </h2>
      
      <p class="authorDescription body article">Penelope Lively is the author of over twenty books of fiction and nonfiction, including the Booker Prize&ndash;winning novel <I>Moon Tiger</I> and the Whitbread Award&ndash;winning novel <I>A Stitch in Time,</I> as well as numerous children&#39;s books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58ec13f4